import { ChangeEvent } from "react";
import { Search, X } from "lucide-react";

import { SearchComplexFilter, ComplexFilterType } from "interfaces/filters";

interface Props {
	filterData: SearchComplexFilter;
	changeFilter: (filter: SearchComplexFilter) => void;
	placeholder: string;
	width?: string;
	background?: string;
	border?: string;
}

const SearchInput = (props: Props): JSX.Element => {
	const { filterData, changeFilter, placeholder, width, background, border } = props;

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;

		changeFilter({
			type: ComplexFilterType.SEARCH,
			value,
			title: value,
		});
	};

	const handleClear = () => {
		changeFilter({
			type: ComplexFilterType.SEARCH,
			value: null,
		});
	};

	return (
		<div
			className="flex relative w-full max-w-[350px] rounded-lg overflow-hidden transition-all duration-300 focus-within:border-primary"
			style={{
				...(width ? { width } : {}),
				background: background || "hsl(var(--secondary) / 0.1)",
				border: border || "1px solid hsl(var(--border))",
			}}
		>
			<div className="absolute left-2 top-1/2 -translate-y-1/2">
				<Search className="h-[15px] w-[15px] text-muted-foreground" />
			</div>

			<input
				placeholder={placeholder}
				onChange={handleChange}
				value={filterData.value || ""}
				className="border-none h-11 md:h-10 px-10 md:px-[38px] w-full outline-none bg-transparent text-foreground text-[15px] md:text-sm placeholder:text-muted-foreground/50"
			/>
			{filterData.value ? (
				<button
					type="button"
					onClick={handleClear}
					className="absolute right-2 top-1/2 -translate-y-1/2 flex cursor-pointer bg-transparent outline-none border-none transition-all duration-200 hover:scale-110"
				>
					<X className="h-[18px] w-[18px] text-muted-foreground" />
				</button>
			) : null}
		</div>
	);
};

export default SearchInput;
